import styled from 'styled-components';
import Theme from '../../../Theme';

import { Text } from '../../../components/core';

type Props = {
  selected?: boolean
  location?: string
  onClick?: any
}

const Container = styled.div`
  height: 72px;
  margin-bottom: 11px;
  text-align: left;
  transition: all 0.1s ease-in-out;

  background-color: ${Theme.colors.BrandOrange};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
  padding: 0 52px;
  margin-left: auto;

  user-select: none;
  cursor: pointer;

  ${({ selected }: Props) => {
    if (selected) {
      return `
        width: 361px;
        opacity: 1;
      `;
    } else {
      return `
        width: 332px;
        opacity: 0.9;
      `;
    }
  }}

  :hover {
    width: 361px;
    height: 82px;
    opacity: 1;
    /* margin-bottom: 6px; */
    /* margin-top: -5px; */
  }

  .location-name-container {
    max-width: 239px;
  }
`;

const LocationMenuItem = ({ selected, location, onClick }: Props) => {
  return (
    <Container selected={selected} onClick={onClick}>
      <div className='location-name-container'>
        <Text variant='Header6'>{location}</Text>
      </div>
    </Container>
  );
};

export default LocationMenuItem;